import styled from 'styled-components';

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
`;
